module.exports = {
  urls: {
    app: 'http://app.hackedu.minikube',
    blog: 'https://blog.hackedu.com',
    cdn: 'https://cdn.hackedu.dev',
    control: 'https://control.hackedu.dev',
    controlK8s: 'http://api-sandbox.hackedu.minikube',
    hacker: 'http://api-hacker.hackedu.minikube',
    quiz: 'http://localhost:5005',
    samy: 'https://samy.hackedu.dev',
    testengine: 'http://api-test-engine.hackedu.minikube',
    www: 'http://localhost:8081',
    linter: 'http://api-linter.hackedu.minikube',
    githubApp: 'https://github.com/apps/hackedu-checks-dev/installations/new?',
    slackApp: 'https://slack.com/oauth/v2/authorize?client_id=801422120564.1385816252582&scope=chat:write,groups:write,im:write,mpim:write,users:read,users:read.email,chat:write.customize&user_scope=',
    microsoftApp: 'https://login.microsoftonline.com/common/adminconsent?client_id=a87ddac5-fd6a-4be1-b367-020e88446adf&redirect_uri=http%3A%2F%2Flocalhost%3A8082%2Fapp-integrations%2Fmicrosoft-teams-callback',
    rewards: 'http://rewards.hackedu.minikube',
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:db591916-a591-4612-85e9-972836b966ae',
  },
  cognito: {
    authData: {
      ClientId: 'i78kjordr8ijhnnhf92sm5p24',
      AppWebDomain: 'auth.hackedu.dev',
      TokenScopesArray: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: 'http://app.hackedu.minikube/auth',
      RedirectUriSignOut: 'http://app.hackedu.minikube',
      UserPoolId: 'us-east-1_SlBDp9xy2',
      AdvancedSecurityDataCollectionFlag: false,
    },
  },
  saml: {
    checkDomainAssociationUri: 'http://api-auth.hackedu.minikube/domain',
  },
  segment: {
    key: 'tfI02bSk23cxAsMsrMDde4xv57FsHjrF',
  },
}
